document.addEventListener('sealsubs:subscription_widget_created', (e) => {
  const widget = e.detail?.element;
  if (!widget) return;

  const sealRow = widget.querySelector('.sls-option-container .seal-row');
  const savingBadge = widget.querySelector('.sls-savings-badge');
  let hasDiscount = false

  const select = widget.querySelector('.sls-select');
  if (!select) return;

  const options = [...select.querySelectorAll('option')];
  const targetOption = options.find(o =>
    o.textContent.toLowerCase().includes('6 weeks')
  );

  if (!targetOption) return;

  select.value = targetOption.value;
  targetOption.selected = true;

  select.dispatchEvent(new Event('change', { bubbles: true }));
  select.dispatchEvent(new Event('input', { bubbles: true }));

  const productFormSellingPlan = document.querySelector('.product-form [data-sls-selling_plan]');
  if (productFormSellingPlan) {
    productFormSellingPlan.value = targetOption.value;
    productFormSellingPlan.dispatchEvent(new Event('change', { bubbles: true }));
  }
  
  requestAnimationFrame(() => {
    const textLength = savingBadge?.textContent?.trim().length || 0;
    hasDiscount = textLength > 0
    widget.classList.toggle('without-discount', textLength === 0);

    if(hasDiscount) {
       injectPurchaseOptionsInfo(sealRow)
    } else {
      const selectContainer = widget.querySelector('.sls-selling-plan-group-options')
      if(selectContainer) {
        const span = document.createElement('span')
        span.classList.add('sls-selling-plan-group-options__subtext')
        span.textContent = window.purchaseOptionLocales.subtext
        selectContainer.appendChild(span)
      }
    }
    injectSubscriptionBenefits(widget, hasDiscount);
    moveOptionsToSealRowOnMobile(widget, sealRow);
    appendAdditionalFirstLineText(widget);
  })  

});

function injectPurchaseOptionsInfo(sealRow) {
  if (!sealRow) return;

  const template = document.querySelector('template[data-purchase-options-info]');
  if (!template) return;

  sealRow.appendChild(template.content.cloneNode(true));
}

function injectSubscriptionBenefits(widget,hasDiscount) {
  const slsOptionContainer = document.querySelector('.sls-option-container');
  if (!slsOptionContainer) return;

  const benefitsTemplate = document.querySelector('template[data-subscription-benefits]');
  if (!benefitsTemplate) return;

  const benefitsContent = benefitsTemplate.content.cloneNode(true);

  if(hasDiscount) {
    moveElIntoContainer({
      container: benefitsContent.querySelector('[data-subscription-price]'),
      el: widget.querySelector('.sls-selling-plan-group-price'),
    });
  }

  moveElIntoContainer({
    container: benefitsContent.querySelector('[data-savings-label]'),
    el: widget.querySelector('.sls-savings-badge'),
  });

  slsOptionContainer.appendChild(benefitsContent);
}

function moveOptionsToSealRowOnMobile(widget, sealRow) {
  if (!widget || !sealRow) return;
  if (window.innerWidth > 749) return;

  const options = widget.querySelector('.sls-selling-plan-group-options');
  if (!options) return;

  if (options.parentElement !== sealRow) {
    sealRow.appendChild(options);
  }
}

function appendAdditionalFirstLineText(widget) {
  const firstLine = widget.querySelector(
    '.sls-selling-plan-group-first-line:has(.sls-selling-plan-group-name) .sls-selling-plan-group-name'
  );
  if (!firstLine) return;

  if (firstLine.querySelector('.sls-selling-plan-group-first-line__additional-text')) return;

  const additional = document.createElement('span');
  additional.className = 'sls-selling-plan-group-first-line__additional-text';
  additional.textContent = window.purchaseOptionLocales.firstLineAdditionalText?  
    window.purchaseOptionLocales.firstLineAdditionalText : 'Easy, repeat deliveries';
  firstLine.appendChild(additional); 
}

function moveElIntoContainer({ container, el }) {
  if (!container || !el) return;
  container.appendChild(el);
}

function parseDataProduct(el) {
  const raw = el.getAttribute('data-product');
  if (!raw) return null;

  const ta = document.createElement('textarea');
  ta.innerHTML = raw;
  const decoded = ta.value;

  try {
    return JSON.parse(decoded);
  } catch (err) {
    console.warn('Failed to parse data-product JSON', err, decoded);
    return null;
  }
}